import { brand } from '../../../tokens/colors/brand';
import { status } from '../../../tokens/colors/status';
import { alphas } from '../../../tokens/colors/system/alphas';

type StatusColor = keyof typeof status;
type BrandColor = keyof typeof brand;
export type ShimmerColor = StatusColor | BrandColor | (string & {});

const colorTokens = { ...status, ...brand };

const resolveColor = (color: string): string => {
  return colorTokens[color as keyof typeof colorTokens] ?? color;
};

export const shimmer = ({
  height = '100%',
  width = '100%',
  lightColor,
  darkColor,
}: {
  height?: string;
  width?: string;
  lightColor?: ShimmerColor;
  darkColor?: ShimmerColor;
}) => {
  const light = lightColor ? resolveColor(lightColor) : alphas['darken-3'];
  const dark = darkColor ? resolveColor(darkColor) : alphas['darken-10'];

  return {
    animation: 'shimmer',
    animationName: 'shimmer',
    backgroundColor: light,
    backgroundImage: `linear-gradient(to right, ${light} 0%, ${dark} 20%, ${light} 40%, ${light} 100%)`,
    backgroundSize: '800',
    height,
    width,
  };
};
